import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface PauseArgusInstanceInput {
  instanceId: string;
}

export function usePauseArgusInstance() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: PauseArgusInstanceInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}/pause`, {
        method: "POST",
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/instances"),
      });
      queryClient.invalidateQueries({
        queryKey: [`/client/argus/instances/${variables.instanceId}`],
      });
    },
  });
}
